import { gql } from "@apollo/client";

import { CUSTOM_VIEW_FIELDS } from "./fragments";

export const CREATE_CUSTOM_VIEW = "createCustomView";
export const UPDATE_CUSTOM_VIEW = "updateCustomView";
export const DELETE_CUSTOM_VIEW = "deleteCustomView";
export const SAVE_CUSTOM_VIEW_AS_NEW = "saveCustomViewAsNew";
export const REORDER_CUSTOM_VIEWS = "reorderCustomViews";
export const SET_ACTIVE_CUSTOM_VIEW = "setActiveCustomView";

export const CREATE_CUSTOM_VIEW_MUTATION = gql`
  mutation ${CREATE_CUSTOM_VIEW}($input: InputCreateCustomView!) {
    ${CREATE_CUSTOM_VIEW}(input: $input) {
      ...CustomViewFields
    }
  }
  ${CUSTOM_VIEW_FIELDS}
`;

export const UPDATE_CUSTOM_VIEW_MUTATION = gql`
  mutation ${UPDATE_CUSTOM_VIEW}($input: InputUpdateCustomView!) {
    ${UPDATE_CUSTOM_VIEW}(input: $input) {
      ...CustomViewFields
    }
  }
  ${CUSTOM_VIEW_FIELDS}
`;

export const DELETE_CUSTOM_VIEW_MUTATION = gql`
  mutation ${DELETE_CUSTOM_VIEW}($id: ID!) {
    ${DELETE_CUSTOM_VIEW}(id: $id) {
      _id
    }
  }
`;

export const SAVE_CUSTOM_VIEW_AS_NEW_MUTATION = gql`
  mutation ${SAVE_CUSTOM_VIEW_AS_NEW}($input: InputSaveCustomViewAsNew!) {
    ${SAVE_CUSTOM_VIEW_AS_NEW}(input: $input) {
      ...CustomViewFields
    }
  }
  ${CUSTOM_VIEW_FIELDS}
`;

export const REORDER_CUSTOM_VIEWS_MUTATION = gql`
  mutation ${REORDER_CUSTOM_VIEWS}($input: InputReorderCustomViews!) {
    ${REORDER_CUSTOM_VIEWS}(input: $input) {
      ...CustomViewFields
    }
  }
  ${CUSTOM_VIEW_FIELDS}
`;

export const SET_ACTIVE_CUSTOM_VIEW_MUTATION = gql`
  mutation ${SET_ACTIVE_CUSTOM_VIEW}($module: CustomViewModule!, $viewId: ID!) {
    ${SET_ACTIVE_CUSTOM_VIEW}(module: $module, viewId: $viewId) {
      module
      viewOrder
      activeViewId
    }
  }
`;
